import { Datagrid, UrlField, ListProps, TextField, FunctionField, Button } from 'react-admin';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CustomList } from '../../components';
import ActiveField from '../../components/ActiveField';
import FileCopy from '@material-ui/icons/FileCopy';

export default function PagesList(props: ListProps) {
  return (
    <CustomList {...props} sort={{ field: 'id', order: 'DESC' }}>
      <Datagrid rowClick="edit">
        
        <TextField label="Título" source="title" />

        <ActiveField label="Ativo" />
        
        <FunctionField label="URL" render={(record) => {
          const url = record.category === 'INTERNAL' ? `/pagina/${record.slug}` : `/p/${record.slug}`
          return (
            <>
              <span>{url}</span>
            
              <CopyToClipboard 
                text={url}
              >
                <Button
                  size="small"
                  title="Clique para copiar"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FileCopy />
                </Button>
                
              </CopyToClipboard>
            </>
        )}} />

      </Datagrid>
    </CustomList>
  );
}
